import { combineReducers } from "redux";
import { userData, socket, gallery, lastPageGallery, media, chats, openedChats, menus, pages, postTypes, languages, userPermissions, accountTypes, tags, categories, translates, users, countData, lang, notificationAlertText, contrast } from "./onStart";


export default combineReducers({
    userData, socket, gallery, lastPageGallery, media, chats, openedChats, menus, pages, postTypes, languages, userPermissions, accountTypes, tags, categories, translates, users, countData, lang, notificationAlertText, contrast
});